module.exports = __webpack_public_path__ + "static/media/menu.153c0394.svg";